import { render, staticRenderFns } from "./TreatmentDetailsHeader.vue?vue&type=template&id=0c363da6&scoped=true"
import script from "./TreatmentDetailsHeader.vue?vue&type=script&lang=js"
export * from "./TreatmentDetailsHeader.vue?vue&type=script&lang=js"
import style0 from "./TreatmentDetailsHeader.vue?vue&type=style&index=0&id=0c363da6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c363da6",
  null
  
)

export default component.exports